"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRequiredInfo = exports.validateRequiredSync = exports.validateRequired = exports.shouldValidate = void 0;
const error_1 = require("../../../error");
const utils_1 = require("../../../utils");
const shouldValidate = (context) => {
    var _a;
    const { component } = context;
    return !!((_a = component.validate) === null || _a === void 0 ? void 0 : _a.required);
};
exports.shouldValidate = shouldValidate;
const validateRequired = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.validateRequiredSync)(context);
});
exports.validateRequired = validateRequired;
const validateRequiredSync = (context) => {
    const error = new error_1.FieldError('required', Object.assign(Object.assign({}, context), { setting: true }));
    const { component, value } = context;
    if (!(0, exports.shouldValidate)(context)) {
        return null;
    }
    return (0, utils_1.componentHasValue)(component, value) ? null : error;
};
exports.validateRequiredSync = validateRequiredSync;
exports.validateRequiredInfo = {
    name: 'validateRequired',
    process: exports.validateRequired,
    processSync: exports.validateRequiredSync,
    shouldProcess: exports.shouldValidate,
};
